// libraries
import React, { useState, useEffect } from "react";
import { useLazyQuery } from "@apollo/react-hooks";
import PropTypes from "prop-types";
import { parse } from "query-string";

// components
import { BackLink } from "./styles";
import ProDownloadSection from "./ProDownloadSection";
import BasicDownloadSection from "./BasicDownloadSection";
import PublicDomainDownloadSection from "./PublicDomainDownloadSection";
import LoadingSpinner from "core/LoadingSpinner";

// Graphql + queries
import { GET_LATEST_PURCHASE } from "photos/queries";
import { UploadLicense } from "js/graphql";

const PhotoDetailDownload = ({ photo, isPurchased, onBack }) => {
    const [purchaseData, setPurchaseData] = useState(null);

    const [loadPurchase, { called, data }] = useLazyQuery(GET_LATEST_PURCHASE, {
        fetchPolicy: "network-only",
        onCompleted: () => setPurchaseData(data)
    });
    useEffect(() => {
        if (isPurchased && photo && photo.id && !called) {
            loadPurchase({
                variables: {
                    photoId: photo.id
                }
            });
        }
    }, [isPurchased, called, loadPurchase, photo]);

    if (isPurchased) {
        if (purchaseData && purchaseData.latestPurchase) {
            return (
                <ProDownloadSection
                    photo={photo}
                    downloadType={purchaseData.latestPurchase.purchaseType}
                />
            );
        } else {
            return <LoadingSpinner />;
        }
    }

    if (photo && photo.license === UploadLicense.Publicdomain) {
        return <PublicDomainDownloadSection photo={photo} />;
    }

    return (
        <>
            <BasicDownloadSection photo={photo} />
            <BackLink onClick={onBack}>Back to all purchase options</BackLink>
        </>
    );
};

PhotoDetailDownload.propTypes = {
    photo: PropTypes.shape({
        id: PropTypes.string.isRequired,
        license: PropTypes.string.isRequired
    }).isRequired,
    isPurchased: PropTypes.bool.isRequired,
    onBack: PropTypes.func.isRequired
};

export default PhotoDetailDownload;
